module.exports = __webpack_public_path__ + "static/media/sw4.c437f031.jpg";